import { isSocialMediaOrNewsMention } from "@/views/reports/helpers";

const REASON_TRANSLATIONS = {
  incorrect: L.MENTIONS_VIEW_HIDDEN_INCORRECT_REASON,
  uninteresting: L.MENTIONS_VIEW_HIDDEN_IRRELEVANT_REASON,
  excluded_topic: L.MENTIONS_VIEW_HIDDEN_EXCLUDED_TOPIC_REASON,
  excluded_source: L.MENTIONS_VIEW_HIDDEN_EXCLUDED_SOURCE_REASON,
};

export const preprocess = (mentions = []) => {
  return mentions.map((originalMention) => {
    let mention = { ...originalMention };

    // Social media mentions have no episode name, so return empty
    if (isSocialMediaOrNewsMention(mention["channel_type"])) {
      mention.episode_title = "";
    }
    if (mention.marked_irrelevant_reason) {
      const reason = mention.marked_irrelevant_reason;
      mention.marked_irrelevant_reason = REASON_TRANSLATIONS[reason] || "";
    }
    return mention;
  });
};
